// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.claim-form-page {
  background-color: rgb(228, 230, 235);
  background-color: rgb(247, 248, 249) !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
}
.claim-form-page .quickAccess-onlyMobile {
  display: none;
}
.claim-form-page .sideNav-pl {
  display: none;
}
.claim-form-page .headers-home {
  width: 100%;
  z-index: 10;
  padding: 0px !important;
  margin: 0px !important;
}
.claim-form-page .row-attachFiles {
  width: 100% !important;
  margin: 0 !important;
}
.claim-form-page .logged-navbar {
  position: sticky;
  top: 0;
  padding: 0px !important;
  z-index: 10;
}
.claim-form-page .dropdowns-containers-navbar {
  margin-top: 0px !important;
  width: 100% !important;
  display: flex;
  padding: 0 !important;
  flex-direction: row;
  align-self: center;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.16);
}
.claim-form-page .community-district-input {
  margin-top: -24px !important;
}
.claim-form-page .box-menu {
  margin-left: 15px;
  margin-bottom: 25px;
  align-self: flex-start !important;
  justify-content: flex-start !important;
}

.box-data-claim {
  background-color: rgb(255, 255, 255);
  height: max-content;
  overflow: auto !important;
  position: sticky !important;
  margin-bottom: 10px;
  padding: 15px;
}

.text-claim-box {
  overflow: auto !important;
}

.form-container-claim {
  background-color: rgba(0, 0, 0, 0);
  width: 95%;
  align-self: center;
  justify-content: center;
}

.item-form {
  margin: 25px;
}

h5 {
  padding: 0px !important;
}

.style-btn-2 {
  background-color: #8f033c !important;
  color: rgb(255, 255, 255) !important;
  width: 140px;
  padding: 15px !important;
  font-size: 10px !important;
  font-family: "Lato", sans-serif !important;
  margin-left: 15px !important;
}

.style-btn-1 {
  background-color: rgb(237, 236, 235) !important;
  color: black !important;
  width: 140px;
  padding: 10px !important;
  font-size: 10px !important;
  font-family: "Lato", sans-serif !important;
}

.custom-file-upload-is-invalid {
  background-color: rgb(255, 255, 255);
  margin-left: 0;
  margin-right: 0;
  border-radius: 5px;
  width: 100% !important;
  max-width: 100%;
  box-sizing: border-box;
  border: 1px solid #ccc;
  display: block;
  padding: 6px 12px;
  cursor: pointer;
  padding-right: calc(1.5em + 0.75rem) !important;
  border-color: #dc3545;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.custom-file-upload {
  background-color: rgb(255, 255, 255);
  margin-left: 0;
  margin-right: 0;
  border-radius: 5px;
  width: 100% !important;
  max-width: 100%;
  box-sizing: border-box;
  border: 1px solid #ccc;
  display: block;
  padding: 6px 12px;
  cursor: pointer;
}

.form-actions-col {
  width: 100%;
}

.form-actions-col .form-actions-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  width: 100%;
  max-width: 100%;
  margin-top: 20px;
}

.form-actions-row .style-btn-1 {
  flex: 0 0 auto;
  width: auto;
  min-width: 110px;
  max-width: 35%;
}

.form-actions-row .style-btn-2 {
  flex: 1 1 auto;
  width: auto;
  min-width: 160px;
  max-width: 55%;
  margin-left: 0 !important;
  white-space: normal;
}

.group-bottom-claim {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 0;
  margin-right: 0;
}

.title-claim {
  font-size: 12px !important;
  font-family: "Lato", sans-serif !important;
}

.body-claim {
  font-size: 11px !important;
  font-family: "Lato", sans-serif !important;
}

li {
  font-size: 11px !important;
  font-family: "Lato", sans-serif !important !important;
}

@media screen and (max-width: 1200px) {
  .sideNav-pl {
    display: flex !important;
  }
  .quick-claim-form {
    display: none !important;
  }
}
@media screen and (max-width: 768px) {
  .claim-container-page {
    align-self: flex-start;
    margin-bottom: 50px;
    margin: 25px;
  }
}
@media screen and (min-width: 768px) {
  .claim-container-page {
    align-self: flex-start;
    margin-bottom: 50px;
    margin: 20px;
  }
}
.file-clear {
  color: #8f033c;
  cursor: pointer;
}

input[type=file] {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/sass/layout/claimform/claimform.scss","webpack://./src/sass/utilities/_mixins.scss","webpack://./src/sass/layout/claimform/claimform.css","webpack://./src/sass/utilities/_variables.scss"],"names":[],"mappings":"AAGA;EACE,oCAAA;ECKA,+CAAA;EACA,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,yBAAA;ACNF;AFDE;EACE,aAAA;AEGJ;AFDE;EACE,aAAA;AEGJ;AFDE;EACE,WAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;AEGJ;AFDE;EACE,sBAAA;EEGJ,oBAAA;AFAE;AEEF;EFCI,gBAAA;EACA,MAAA;EACA,uBAAA;EECJ,WAAA;AFEE;AEAF;EFEI,0BAAA;EACA,sBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,+CAAA;EEAJ,4CAAA;AFEE;AEAF;EACA,4BAAA;AFGE;AEDF;EFGI,iBAAA;EACA,mBAAA;EACA,iCAAA;EEDJ,sCAAA;AACA;;AAEA;EFIE,oCAAA;EACA,mBAAA;EACA,yBAAA;EAEA,2BAAA;EACA,mBAAA;EEHF,aAAA;AAEA;;AAEA;EAAA,yBAAA;AAEA;;AAEA;EFIE,kCAAA;EACA,UAAA;EACA,kBAAA;EEHF,uBAAA;AAEA;;AAEA;EAAA,YAAA;AAEA;;AAEA;EAAA,uBAAA;AAEA;;AAEA;EFIE,oCAAA;EACA,oCAAA;EACA,YAAA;EACA,wBAAA;EACA,0BAAA;EACA,0CAAA;EEHF,4BAAA;AAEA;;AAEA;EFIE,+CAAA;EACA,uBAAA;EACA,YAAA;EACA,wBAAA;EACA,0BAAA;EEHF,0CAAA;AAEA;;AAEA;EFIE,oCAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EEHF,sBAAA;EAEE,eAAe;EFIjB,sBAAA;EACE,sBAAA;EACA,cAAA;EEHF,iBAAA;EAEE,eAAe;EFIjB,+CAAA;EACE,qBAAA;EACA,yDGjHK;ED8GP,4BAAA;EAEE,2DAA2D;EFI7D,gEAAA;AEFA;;AACA;EAEE,oCAAoC;EFItC,cAAA;EACE,eAAA;EEFA,kBFGE;EEHF,sBAAA;EFKA,eAAA;EEFA,sBFGE;EEHF,sBAAA;EACF,cAAA;EFKA,iBAAA;EACE,eAAA;AEFF;;AAEA;EAAE,WAAA;AACF;;AAGA;EACE,aFIE;EEHF,mBFIE;EEHF,iBFIE;EEJF,mBAAA;EACF,yBAAA;EFOA,SAAA;EACE,WAAA;EACA,eAAA;EELF,gBAAA;AAEA;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,qDAAqD;AACvD;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;EACd;AACF;AACA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;EACd;AACF;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf","sourcesContent":["@import \"../../utilities/mixins\";\n@import \"../../utilities/variables\";\n\n.claim-form-page {\n  background-color: rgb(228 230 235);\n  @include settingsPage();\n  .quickAccess-onlyMobile {\n    display: none;\n  }\n  .sideNav-pl {\n    display: none;\n  }\n  .headers-home {\n    width: 100%;\n    z-index: 10;\n    padding: 0px !important;\n    margin: 0px !important;\n  }\n  .row-attachFiles {\n    width: 100% !important;\n    margin: 0 !important;\n  }\n\n  .logged-navbar {\n    // margin-bottom: 20px !important;\n    position: sticky;\n    top: 0;\n    padding: 0px !important;\n    z-index: 10;\n  }\n\n  .dropdowns-containers-navbar {\n    margin-top: 0px !important;\n    width: 100% !important;\n    display: flex;\n    padding: 0 !important;\n    flex-direction: row;\n    align-self: center;\n    background: #ffffff 0% 0% no-repeat padding-box;\n    box-shadow: 0px 0px 15px rgb(0 0 0 / 16%);\n  }\n  .community-district-input {\n    margin-top: -24px !important;\n  }\n\n  .box-menu {\n    margin-left: 15px;\n    margin-bottom: 25px;\n    align-self: flex-start !important;\n    justify-content: flex-start !important;\n  }\n}\n\n.box-data-claim {\n  background-color: $White;\n  height: max-content;\n  overflow: auto !important;\n  position: sticky !important;\n  // top: 140px;\n  margin-bottom: 10px;\n  padding: 15px;\n}\n\n.text-claim-box {\n  overflow: auto !important;\n}\n\n.form-container-claim {\n  background-color: $Transparent;\n  width: 95%;\n  align-self: center;\n  justify-content: center;\n}\n\n.item-form {\n  margin: 25px;\n}\n\nh5 {\n  padding: 0px !important;\n}\n\n.style-btn-2 {\n  background-color: #8f033c !important;\n  color: $White !important;\n  width: 140px;\n  padding: 15px !important;\n  font-size: 10px !important;\n  font-family: $Font;\n  margin-left: 15px !important;\n}\n\n.style-btn-1 {\n  background-color: rgba(237, 236, 235, 1) !important;\n  color: black !important;\n  width: 140px;\n  padding: 10px !important;\n  font-size: 10px !important;\n  font-family: $Font;\n}\n\n.custom-file-upload-is-invalid {\n  background-color: $White;\n  margin-left: 0;\n  margin-right: 0;\n  border-radius: 5px;\n  width: 100% !important;\n  max-width: 100%;\n  box-sizing: border-box;\n  border: 1px solid #ccc;\n  display: block;\n  padding: 6px 12px;\n  cursor: pointer;\n  padding-right: calc(1.5em + 0.75rem) !important;\n  border-color: #dc3545;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n.custom-file-upload {\n  background-color: $White;\n  margin-left: 0;\n  margin-right: 0;\n  border-radius: 5px;\n  width: 100% !important;\n  max-width: 100%;\n  box-sizing: border-box;\n  border: 1px solid #ccc;\n  display: block;\n  padding: 6px 12px;\n  cursor: pointer;\n}\n\n.form-actions-col {\n  width: 100%;\n}\n\n.form-actions-col .form-actions-row {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  width: 100%;\n  max-width: 100%;\n  margin-top: 20px;\n}\n\n.form-actions-row .style-btn-1 {\n  flex: 0 0 auto;\n  width: auto;\n  min-width: 110px;\n  max-width: 35%;\n}\n\n.form-actions-row .style-btn-2 {\n  flex: 1 1 auto;\n  width: auto;\n  min-width: 160px;\n  max-width: 55%;\n  margin-left: 0 !important;\n  white-space: normal;\n}\n\n.group-bottom-claim {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-top: 0;\n  margin-right: 0;\n}\n\n.title-claim {\n  font-size: 12px !important;\n  font-family: $Font;\n}\n\n.body-claim {\n  font-size: 11px !important;\n  font-family: $Font;\n}\n\nli {\n  font-size: 11px !important;\n  font-family: $Font !important;\n}\n\n@media screen and (max-width: 1200px) {\n  .sideNav-pl {\n    display: flex !important;\n  }\n  .quick-claim-form {\n    display: none !important;\n  }\n}\n@media screen and (max-width: 768px) {\n  .claim-container-page {\n    align-self: flex-start;\n    margin-bottom: 50px;\n    margin: 25px;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .claim-container-page {\n    align-self: flex-start;\n    margin-bottom: 50px;\n    margin: 20px;\n  }\n}\n\n.file-clear {\n  color: #8f033c;\n  cursor: pointer;\n}\n\ninput[type=\"file\"] {\n  display: none;\n}","@import \"./variables\";\n\n@mixin flexCenter($justify-content, $align-items) {\n  display: flex;\n  justify-content: $justify-content;\n  align-items: $align-items;\n}\n\n@mixin settingsPage() {\n  background-color: $MainBackgroundColor !important;\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n",".claim-form-page {\n  background-color: rgb(228, 230, 235);\n  background-color: rgb(247, 248, 249) !important;\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n.claim-form-page .quickAccess-onlyMobile {\n  display: none;\n}\n.claim-form-page .sideNav-pl {\n  display: none;\n}\n.claim-form-page .headers-home {\n  width: 100%;\n  z-index: 10;\n  padding: 0px !important;\n  margin: 0px !important;\n}\n.claim-form-page .row-attachFiles {\n  width: 100% !important;\n  margin: 0 !important;\n}\n.claim-form-page .logged-navbar {\n  position: sticky;\n  top: 0;\n  padding: 0px !important;\n  z-index: 10;\n}\n.claim-form-page .dropdowns-containers-navbar {\n  margin-top: 0px !important;\n  width: 100% !important;\n  display: flex;\n  padding: 0 !important;\n  flex-direction: row;\n  align-self: center;\n  background: #ffffff 0% 0% no-repeat padding-box;\n  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.16);\n}\n.claim-form-page .community-district-input {\n  margin-top: -24px !important;\n}\n.claim-form-page .box-menu {\n  margin-left: 15px;\n  margin-bottom: 25px;\n  align-self: flex-start !important;\n  justify-content: flex-start !important;\n}\n\n.box-data-claim {\n  background-color: rgb(255, 255, 255);\n  height: -moz-max-content;\n  height: max-content;\n  overflow: auto !important;\n  position: sticky !important;\n  margin-bottom: 10px;\n  padding: 15px;\n}\n\n.text-claim-box {\n  overflow: auto !important;\n}\n\n.form-container-claim {\n  background-color: rgba(0, 0, 0, 0);\n  width: 95%;\n  align-self: center;\n  justify-content: center;\n}\n\n.item-form {\n  margin: 25px;\n}\n\nh5 {\n  padding: 0px !important;\n}\n\n.style-btn-2 {\n  background-color: #8f033c !important;\n  color: rgb(255, 255, 255) !important;\n  width: 140px;\n  padding: 15px !important;\n  font-size: 10px !important;\n  font-family: \"Lato\", sans-serif !important;\n  margin-left: 15px !important;\n}\n\n.style-btn-1 {\n  background-color: rgb(237, 236, 235) !important;\n  color: black !important;\n  width: 140px;\n  padding: 10px !important;\n  font-size: 10px !important;\n  font-family: \"Lato\", sans-serif !important;\n}\n\n.custom-file-upload-is-invalid {\n  background-color: rgb(255, 255, 255);\n  margin-left: 0;\n  margin-right: 0;\n  border-radius: 5px;\n  width: 100% !important;\n  max-width: 100%;\n  box-sizing: border-box;\n  border: 1px solid #ccc;\n  display: block;\n  padding: 6px 12px;\n  cursor: pointer;\n  padding-right: calc(1.5em + 0.75rem) !important;\n  border-color: #dc3545;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n.custom-file-upload {\n  background-color: rgb(255, 255, 255);\n  margin-left: 0;\n  margin-right: 0;\n  border-radius: 5px;\n  width: 100% !important;\n  max-width: 100%;\n  box-sizing: border-box;\n  border: 1px solid #ccc;\n  display: block;\n  padding: 6px 12px;\n  cursor: pointer;\n}\n\n.form-actions-col {\n  width: 100%;\n}\n\n.form-actions-col .form-actions-row {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  width: 100%;\n  max-width: 100%;\n  margin-top: 20px;\n}\n\n.form-actions-row .style-btn-1 {\n  flex: 0 0 auto;\n  width: auto;\n  min-width: 110px;\n  max-width: 35%;\n}\n\n.form-actions-row .style-btn-2 {\n  flex: 1 1 auto;\n  width: auto;\n  min-width: 160px;\n  max-width: 55%;\n  margin-left: 0 !important;\n  white-space: normal;\n}\n\n.group-bottom-claim {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-top: 0;\n  margin-right: 0;\n}\n\n.title-claim {\n  font-size: 12px !important;\n  font-family: \"Lato\", sans-serif !important;\n}\n\n.body-claim {\n  font-size: 11px !important;\n  font-family: \"Lato\", sans-serif !important;\n}\n\nli {\n  font-size: 11px !important;\n  font-family: \"Lato\", sans-serif !important !important;\n}\n\n@media screen and (max-width: 1200px) {\n  .sideNav-pl {\n    display: flex !important;\n  }\n  .quick-claim-form {\n    display: none !important;\n  }\n}\n@media screen and (max-width: 768px) {\n  .claim-container-page {\n    align-self: flex-start;\n    margin-bottom: 50px;\n    margin: 25px;\n  }\n}\n@media screen and (min-width: 768px) {\n  .claim-container-page {\n    align-self: flex-start;\n    margin-bottom: 50px;\n    margin: 20px;\n  }\n}\n.file-clear {\n  color: #8f033c;\n  cursor: pointer;\n}\n\ninput[type=file] {\n  display: none;\n}/*# sourceMappingURL=claimform.css.map */","// Utils\n$DecorationNone: none;\n$Font: \"Lato\", sans-serif !important;\n$Font-size-navbar: 12px;\n$LetterSpacing: 0px;\n\n// Colors\n$Transparent: rgba(0, 0, 0, 0);\n$RedColor: rgb(143, 0, 60, 1);\n$White: rgba(255, 255, 255, 1);\n$Black: rgba(26, 25, 25, 1);\n$MainBackgroundColor: rgba(247, 248, 249, 1);\n$SecondaryBackgroundColor: rgba(221, 208, 208, 0.5);\n$GrayColor: rgba(204, 204, 204, 1);\n$LinkColor: rgba(18, 101, 183, 1);\n$LinkSecondColor: rgba(78, 125, 162, 1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
